module.exports = __webpack_public_path__ + "img/Salad_Buffet.6fb78e98.jpg";